(function () {
  "use strict";
  if (window.__ib2ItPolish) return;
  window.__ib2ItPolish = true;
  // PDP video rails: body IT / DE / GB / US, face IT / EN. Rendered ids end with __<block id>.
  var railSelector = ["bc_8841bbb45c840a", "bc_71376e016b30ea", "bc_651a2c82a28641", "bc_25f2929f997da9", "face_it_235", "face_en_232"]
    .map(function (id) { return '[id$="__' + id + '"]'; }).join(",");
  var easing = "cubic-bezier(.2,.7,.2,1)";
  var labels = /^it\b/i.test(document.documentElement.lang || "") ? ["Video precedente", "Video successivo"] : ["Previous video", "Next video"];
  var closed = { height: "0px", opacity: "0", paddingTop: "0px", paddingBottom: "0px" };

  function reduced() { return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; }

  /* Accordions: 300 ms height + opacity, inline styles only, [open] kept until a close ends. */
  function target(detail) { return detail._ib2Animation ? detail._ib2Target : detail.open; }
  function frame(el) {
    var cs = window.getComputedStyle(el);
    return { height: el.getBoundingClientRect().height + "px", opacity: cs.opacity, paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom };
  }
  function clear(el) { ["height", "opacity", "paddingTop", "paddingBottom", "overflow", "boxSizing"].forEach(function (p) { el.style[p] = ""; }); }
  function settle(detail, opening) {
    detail.classList.remove("ib2-it-polish-closing");
    if (opening) return;
    detail.open = false;
    if (detail._ib2RestoreName) { detail.setAttribute("name", detail._ib2RestoreName); detail._ib2RestoreName = null; }
  }
  function animate(detail, opening) {
    var content = detail.querySelector(":scope > .ib2-accordion__content");
    var from = detail.open && content && content.getClientRects().length ? frame(content) : closed;
    var running = detail._ib2Animation;
    detail._ib2Animation = null;
    if (running) running.cancel();
    detail._ib2Target = opening;
    if (opening) detail.open = true;
    if (!content || !content.animate || reduced()) { if (content) clear(content); settle(detail, opening); return; }
    clear(content);
    detail.classList.toggle("ib2-it-polish-closing", !opening);
    var to = opening ? frame(content) : closed;
    content.style.overflow = "hidden";
    content.style.boxSizing = "border-box";
    var animation = content.animate([from, to], { duration: 300, easing: easing, fill: "forwards" });
    detail._ib2Animation = animation;
    animation.onfinish = function () {
      if (detail._ib2Animation !== animation) return;
      detail._ib2Animation = null;
      settle(detail, opening);
      animation.cancel();
      clear(content);
    };
  }
  // <details name> groups: the browser would close the other open item instantly, so drop its name while it animates shut.
  function openGroup(detail) {
    var name = detail.getAttribute("name") || detail._ib2RestoreName;
    if (!name) return;
    document.querySelectorAll("details.ib2-accordion").forEach(function (other) {
      if (other === detail || !other.open || (other.getAttribute("name") || other._ib2RestoreName) !== name) return;
      if (other.hasAttribute("name")) { other._ib2RestoreName = name; other.removeAttribute("name"); }
      if (target(other)) animate(other, false);
    });
    if (detail._ib2RestoreName) { detail.setAttribute("name", detail._ib2RestoreName); detail._ib2RestoreName = null; }
  }
  document.addEventListener("click", function (event) {
    var summary = event.target.closest && event.target.closest("details.ib2-accordion > summary");
    if (!summary) return;
    event.preventDefault();
    var detail = summary.parentElement;
    var opening = !target(detail);
    if (opening) openGroup(detail);
    animate(detail, opening);
  });

  /* Rails: prev/next arrows (CSS shows them only >= 769 px with a fine pointer). No wrapper: the controls sit
     next to the rail and are placed over it, so the parent's :has(> rail) rules keep matching. */
  function initRail(rail) {
    if (rail._ib2Polish || !rail.parentElement) return;
    rail._ib2Polish = true;
    var host = rail.parentElement;
    if (window.getComputedStyle(host).position === "static") host.style.position = "relative";
    var controls = document.createElement("div");
    controls.className = "ib2-it-polish-carousel__controls";
    controls.setAttribute("role", "group");
    function button(label, path) {
      var el = document.createElement("button");
      el.type = "button";
      el.setAttribute("aria-label", label);
      el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + path + '"></path></svg>';
      return el;
    }
    var prev = button(labels[0], "M15 18l-6-6 6-6");
    var next = button(labels[1], "M9 18l6-6-6-6");
    controls.append(prev, next);
    rail.insertAdjacentElement("afterend", controls);
    function update() {
      controls.style.top = rail.offsetTop + rail.offsetHeight / 2 + "px";
      controls.style.left = rail.offsetLeft + "px";
      controls.style.width = rail.offsetWidth + "px";
      var max = rail.scrollWidth - rail.clientWidth;
      controls.hidden = max <= 1;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= max - 1;
    }
    function step() {
      var card = Array.prototype.find.call(rail.children, function (el) { return el.getBoundingClientRect().width > 0; });
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function move(direction) { rail.scrollBy({ left: direction * step(), behavior: reduced() ? "auto" : "smooth" }); }
    prev.addEventListener("click", function () { move(-1); });
    next.addEventListener("click", function () { move(1); });
    // ib2-body-en-ugc.js also autoplays the EN body rail by moving the first card to the end every 1.8 s (paused while the
    // row is hovered): on a scroll-snap rail that re-snaps in place and reloads the moved video, so keep it paused.
    function holdAutoplay() { rail.dispatchEvent(new MouseEvent("mouseenter")); }
    holdAutoplay();
    rail.addEventListener("mouseleave", function () { setTimeout(holdAutoplay); });
    if (autoplayRail.test(rail.id)) autoplay(rail, host, step);
    rail.addEventListener("scroll", update, { passive: true });
    if (window.ResizeObserver) { var ro = new ResizeObserver(update); ro.observe(rail); ro.observe(host); }
    window.addEventListener("resize", update);
    update();
  }
  /* EN body rails DE / GB / US autoplay (Simone 3B; IT and face stay manual): one card every 3 s by scrolling, back to the
     start after the last. Paused on mouse hover, keyboard focus, hidden tab, off-screen, reduced motion, and until 5 s after
     any touch, drag, wheel, key or arrow use. Cards never move in the DOM, so videos keep playing where they were. */
  var autoplayRail = /__(bc_71376e016b30ea|bc_651a2c82a28641|bc_25f2929f997da9)$/;
  function autoplay(rail, host, step) {
    var hover = false, onScreen = !window.IntersectionObserver, lastUser = 0, due = Date.now() + 3000;
    host.addEventListener("pointerenter", function (event) { hover = event.pointerType === "mouse"; });
    host.addEventListener("pointerleave", function () { hover = false; });
    ["pointerdown", "pointerup", "touchstart", "touchend", "wheel", "keydown"].forEach(function (type) {
      host.addEventListener(type, function () { lastUser = Date.now(); }, { passive: true });
    });
    if (!onScreen) new IntersectionObserver(function (entries) { onScreen = entries[entries.length - 1].isIntersecting; }).observe(rail);
    setInterval(function () {
      var now = Date.now(), focus = document.activeElement;
      if (now - lastUser < 5000) { due = lastUser + 5000; return; }
      if (hover || !onScreen || document.hidden || reduced() || (focus && host.contains(focus) && focus.matches(":focus-visible"))) { due = now + 3000; return; }
      if (now < due) return;
      due = now + 3000;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 1) return;
      if (rail.scrollLeft >= max - 1) rail.scrollTo({ left: 0, behavior: "smooth" });
      else rail.scrollBy({ left: step(), behavior: "smooth" });
    }, 250);
  }
  function init() { document.querySelectorAll(railSelector).forEach(initRail); }
  document.addEventListener("shopify:section:load", init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true }); else init();
})();
